const serverBase = "https://techminis.com";
const jsBase = process.env.NEXT_PUBLIC_MOBILE_BIG_SHYFT_JS_BASE_URL;

const apiBase = `${serverBase}/api/v2`;
const apiSeoBase = `${serverBase}/api`;
const apiV3Base = `${serverBase}/api/v3`;

export { apiBase, apiSeoBase, serverBase, jsBase, apiV3Base };
